import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'

import api from "assets/services/api";


function ModalUpdateSubSynthetics(props) {

    const [br, setBR] = useState(false);
    const [description, setDescription] = useState(props.props.description);
    const [code, setCode] = useState(props.props.code);
    const [synthetics, setSynthetics] = useState([]);
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);
    const [id_synthetic, setId_synthetic] = useState("");

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    useEffect(()=>{
        getAllSynthetics()
    },[])

    async function getAllSynthetics() {
        try {
            const response = await api.get('/synthetic/all?id_admin=' + storageId);

            setSynthetics(response.data);

        } catch (error) {
            alert('erro: ' + error)
        }
    }

    async function handleUpdateSynthetics(e) {
        e.preventDefault();
        const response = await api.put('/subsynthetic/' + props.props.id, {
            code:code,
            description: description,
            id_synthetic: id_synthetic,
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllSubSynthetics();
        props.onHide();
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar Sintético
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdateSynthetics}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} xs={2} controlId="formGridDescription">
                            <Form.Label>Código</Form.Label>
                            <Form.Control onChange={event => setCode(event.target.value)} value={code} type="text" placeholder="Nome da Sintético" />
                        </Form.Group>
                        <Form.Group as={Col} xs={10} controlId="formGridDescription">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control onChange={event => setDescription(event.target.value)} value={description} type="text" placeholder="Nome da Sintético" />
                        </Form.Group>
                    </Form.Row>                    
                    <Form.Row>
                        <Form.Group as={Col} xs={12} controlId="formGridDescription">
                            <Form.Label>Sintéticos</Form.Label>
                            <Form.Control onChange={event => setId_synthetic(event.target.value)} as="select" value={id_synthetic}>
                                {synthetics.map(synthetic => (
                                    <option key={String(synthetic.id)} value={synthetic.id}>{synthetic.code} - {synthetic.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>                    
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Editar Sintético
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Sintético editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateSubSynthetics;